import { IReportingEntity, ReportingEntity } from './ReportingEntity';
import { IProject } from './Project';
import { IUser } from './User';
import { IMilestone } from './Milestone';
import { IWorkStreamUpdate } from './WorkStreamUpdate';

export interface IWorkStream extends IReportingEntity {
    WorkStreamCode: string;
    ProjectID: number | null;
    LeadUserID: number | null;
    RagOptionID: number | null;
    TaskManagementOptionID?: number;
    ExternalAppName?: string;
    App03WorkflowID?: number;
    Project?: IProject;
    LeadUser?: IUser;
    Milestones?: IMilestone[];
    WorkStreamUpdates?: IWorkStreamUpdate[];
}

export class WorkStream extends ReportingEntity implements IWorkStream {
    public WorkStreamCode = '';
    public ProjectID = null;
    public LeadUserID = null;
    public RagOptionID = null;
    public TaskManagementOptionID = WorkStreamTaskManagementOptions.NoTaskManagement; //default
    public ExternalAppName = null;
    public App03WorkflowID = null;
}

export enum WorkStreamTaskManagementOptions {
    NoTaskManagement = 1,
    ExternalTaskManagement = 2,
    ZedXGroupWorkStreams = 3,
    ZedXAgileSprints = 4
}